import "isomorphic-fetch";
import axios from 'axios';
import ReactPiwik from 'react-piwik';

import { API_ENDPOINTS } from '../config/api';
import { searchConstants } from '../_constants'
import { history, checkUnauthorized } from '../_helpers';

function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

function searchHasErrored(bool) {
  return {
    type: searchConstants.SEARCH_HAS_ERRORED,
    hasErrored: bool
  };
}

function searchIsLoading(bool) {
  return {
    type: searchConstants.SEARCH_IS_LOADING,
    isLoading: bool
  };
}

function searchFetchDataSuccess(search) {
  return {
    type: searchConstants.SEARCH_FETCH_DATA_SUCCESS,
    search
  };
}

function searchFetchMoreDataSuccess(search) {
  return {
    type: searchConstants.SEARCH_FETCH_MORE_DATA_SUCCESS,
    search
  };
}

function _setSearchString(searchString) {
  return {
    type: searchConstants.SEARCH_SET_SEARCHSTRING,
    searchString
  }
}

function setSearchFilterDispatch(searchFilter) {
  return {
    type: searchConstants.SEARCH_SET_FILTER,
    searchFilter
  }
}

export function setSearchString(searchString) {
  return (dispatch) => {
    dispatch(_setSearchString(searchString));
  }
}

export function setSearchFilter(searchFilter) {
  return (dispatch) => {
    dispatch(setSearchFilterDispatch(searchFilter));
  }
}

export function searchFetchData(query) { // add rootId
  return (dispatch) => {
    dispatch(searchIsLoading(true));
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',  
      'Authorization': `Bearer ${user.token}`
    }

    axios({
      method: 'post',
      url: API_ENDPOINTS.ASSETS.SEARCH,
      data: { 
        searchString: query.query,
        lang: query.lang || 'DE'
      },
      params: {
        page: 1,
        pageSize: 50
      },
      headers
    })
    .then((response) => {
      checkUnauthorized(response, response.statusText);
      if(response.status === 403)
        history.push('/login');
      dispatch(searchIsLoading(false));
      dispatch(searchHasErrored(false));
      
      // Neue API Struktur: Pagination mit entities
      const searchData = {
        results: response.data.entities || [],
        total: response.data.total || 0,
        page: response.data.page || 1,
        pageSize: response.data.pageSize || 50
      };
      
      ReactPiwik.push(['trackSiteSearch', query.query, "search", searchData.results.length]);
      ReactPiwik.push(['trackPageView']);
      return searchData;
    })
    .then((search) => {
      dispatch(searchFetchDataSuccess(search));

      // Filter nach rootId falls vorhanden
      let results = search.results;
      if (query.rootId) {
        results = results.filter(r => r.nodeId === query.rootId);
      }
      
      const grouped = groupBy(results, item => item.nodeId);
      let groups = [];
      for (var [key] of grouped) {
        groups.push(String(key));
      }
      dispatch(setSearchFilterDispatch(groups));

    })
    .catch((error) => {
      console.error('Search error:', error);
      dispatch(searchHasErrored(true));
      dispatch(searchIsLoading(false));
    });
  };
}

export function searchFetchMoreData(query, page) {
  return (dispatch) => {
    dispatch(searchIsLoading(true));
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',  
      'Authorization': `Bearer ${user.token}`
    }

    return axios({
      method: 'post',
      url: API_ENDPOINTS.ASSETS.SEARCH,
      data: { 
        searchString: query.query,
        lang: query.lang || 'DE'
      },
      params: {
        page: page,
        pageSize: 50
      },
      headers
    })
    .then((response) => {
      checkUnauthorized(response, response.statusText);
      if(response.status === 403)
        history.push('/login');
      dispatch(searchIsLoading(false));
      dispatch(searchHasErrored(false));
      
      // Neue API Struktur: Pagination mit entities
      const searchData = {
        results: response.data.entities || [],
        total: response.data.total || 0,
        page: response.data.page || page,
        pageSize: response.data.pageSize || 50
      };
      
      return searchData;
    })
    .then((search) => {
      dispatch(searchFetchMoreDataSuccess(search));
      return search;
    })
    .catch((error) => {
      console.error('Search more error:', error);
      dispatch(searchHasErrored(true));
      dispatch(searchIsLoading(false));
      throw error;
    });
  };
}
